import {
  ApiFile,
  useCreateFileReservationMutation,
  useFinalizeFileReservationMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';



export function useMutation() {
  const [
    createFileReservation,
    createFileReservationTuple
  ] = useCreateFileReservationMutation({
  });
  const [
    finalizeFileReservation,
    finalizeFileReservationTuple
  ] = useFinalizeFileReservationMutation({
  });

  const fnWrappedMutate = useCallback(
    async (file: File) => {
      const {
        data
      } = await createFileReservation({
        variables: {
          input: {
            fileName: file.name ?? '',
            mimeType: file.type,
            sizeBytes: file.size
          }
        }
      });

      if (data?.createFileReservation?.signedUploadUrl) {
        try {
          await fetch(data.createFileReservation.signedUploadUrl, {
            method: 'PUT',
            body: file
          });
        } catch (error) {
          debugger;
        }

        const result = await finalizeFileReservation({
          variables: {
            id: data.createFileReservation.id
          }
        });

        return result.data?.finalizeFileReservation?.apiFile?.id ?? '';
      }
    },
    [
      createFileReservation,
      finalizeFileReservation
    ]
  );



  const wrappedData = useMemo(
    (): Pick<ApiFile, 'id' | 'url'> => ({
      id: finalizeFileReservationTuple.data?.finalizeFileReservation?.apiFile?.id ?? '',
      url: finalizeFileReservationTuple.data?.finalizeFileReservation?.apiFile?.url ?? ''
    }),
    [finalizeFileReservationTuple.data?.finalizeFileReservation]
  );



  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...createFileReservationTuple,
        loading: createFileReservationTuple.loading || finalizeFileReservationTuple.loading,
        data: wrappedData
      }
    ] as const,
    [
      fnWrappedMutate,
      createFileReservationTuple,
      finalizeFileReservationTuple.loading,
      wrappedData
    ]
  );
}
